import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ResourceSharingOffer } from 'app/entity/models/rapido-offer';
import { Subject, Subscription } from 'rxjs';
import { updateShouldCloseModal } from 'user/actions/user-profile.actions';
import { getShouldCloseModal, UserState } from 'user/reducers/user.reducer';

@Component({
  selector: "app-get-it-rapido-confirm-dialog",
  templateUrl: "./get-it-rapido-confirm-dialog.component.html",
  styleUrls: ["./get-it-rapido-confirm-dialog.component.scss"],
})
export class GetItRapidoConfirmDialogComponent {
  @Input() public offer: ResourceSharingOffer;
  public formDataSubject = new Subject<any>();

  private readonly subscription = new Subscription();

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly store: Store<UserState>
  ) {}

  public onClose() {
    this.store.dispatch(updateShouldCloseModal({ errorMessage: '' }));
    this.activeModal.dismiss();
  }

  public onGetIt(event: Event) {
    event.stopPropagation();
    this.formDataSubject.next(true);
    this.subscription.add(
      this.store.select(getShouldCloseModal).subscribe((shouldCloseModal) => {
        if (shouldCloseModal) {
          this.activeModal.close();
        }
      })
    );
  }
}
